import React, { FC, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
// eslint-disable-next-line import/no-cycle
import ModernSidebar from './sections/ModernSidebar';
// eslint-disable-next-line import/no-cycle
import ModernHeader from './sections/ModernHeader';
import { CURRENT_VERSION } from '../../constants';
import { DashboardContext } from '../../context';

const ModernDashboard: FC = () => {
  const user = useSelector((state: any) => state.auth.user);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const contextValue = useMemo(
    () => ({ sidebarOpen, setSidebarOpen, sidebarCollapsed, setSidebarCollapsed }),
    [sidebarOpen, sidebarCollapsed]
  );

  return (
    <DashboardContext.Provider value={contextValue}>
      <div className='min-h-screen bg-gray-50 dark:bg-gray-950'>
        {/* Sidebar */}
        <ModernSidebar />

        {/* Mobile overlay */}
        {sidebarOpen && (
          <div
            className='fixed inset-0 bg-gray-900/50 backdrop-blur-sm z-40 lg:hidden'
            onClick={() => setSidebarOpen(false)}
            role='button'
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Escape' && setSidebarOpen(false)}
            aria-label='Close sidebar'
          />
        )}

        {/* Main content */}
        <div
          className={`
            min-h-screen transition-all duration-300 ease-out
            ${sidebarCollapsed ? 'lg:ml-20' : 'lg:ml-72'}
          `}
        >
          {/* Header */}
          <ModernHeader user={user} />

          {/* Page content */}
          <main className='pt-20 lg:pt-[72px] p-4 lg:p-6'>
            <div className='max-w-7xl mx-auto'>
              <Outlet />
            </div>

            {/* Footer - Removed as per user request */}
            <footer className='mt-12 pb-6 text-center hidden'>
              <p className='text-sm text-primary-500 font-medium mb-1'>
                v{CURRENT_VERSION}
              </p>
              <p className='text-xs text-gray-400 dark:text-gray-500'>
                Designed & Developed by{' '}
                <a
                  href='https://kimeramoses.com'
                  target='_blank'
                  rel='noreferrer'
                  className='text-primary-500 hover:text-primary-600 transition-colors'
                >
                  MOXTECH DEVELOPERS
                </a>
              </p>
            </footer>
          </main>
        </div>
      </div>
    </DashboardContext.Provider>
  );
};

export default ModernDashboard;
